import { MutationTree } from 'vuex';
import { ApplicationFormNumberSettingState, ApplicationFormNumberSetting, PrefixPreview } from './types';
import * as types from './mutation-types';
import { ErrorDetail } from '../../types';

export const mutations: MutationTree<ApplicationFormNumberSettingState> = {
    // 申請管理番号情報取得系
    [types.SHOW_START](state) {
        const showState = state.show;
        showState.error = false;
        showState.errorCode = undefined;
        showState.errorMsg = undefined;
        showState.isProcessing = true;
        showState.isFetchSuccess = false;
    },

    [types.SHOW_SUCCESS](state, payload: { applicationFormNumberSetting: ApplicationFormNumberSetting }) {
        state.applicationFormNumberSetting = payload.applicationFormNumberSetting;

        const showState = state.show;
        showState.isProcessing = false;
        showState.isFetchSuccess = true;
    },

    [types.SHOW_FAILURE](state, payload: { code: string; message: string }) {
        const showState = state.show;
        showState.errorCode = payload.code;
        showState.errorMsg = payload.message;
        showState.error = true;
        showState.isProcessing = false;
        showState.isFetchSuccess = false;
    },

    // 申請管理番号情報更新系
    [types.UPDATE_START](state) {
        const updateState = state.update;
        updateState.error = false;
        updateState.errorTitle = undefined;
        updateState.errorDetails = undefined;
        updateState.isProcessing = true;
    },

    [types.UPDATE_SUCCESS](state) {
        const updateState = state.update;
        updateState.isProcessing = false;
    },

    [types.UPDATE_FAILURE](state, payload: { errorTitle: string; errorDetails: Array<ErrorDetail> }) {
        const updateState = state.update;
        updateState.errorTitle = payload.errorTitle;
        updateState.errorDetails = payload.errorDetails;
        updateState.error = true;
        updateState.isProcessing = false;
    },

    // 申請管理番号情報取得系
    [types.PREFIX_PREVIEW_START](state) {
        const previewState = state.preview;
        previewState.error = false;
        previewState.errorTitle = undefined;
        previewState.errorDetails = undefined;
        previewState.isProcessing = true;
    },

    [types.PREFIX_PREVIEW_SUCCESS](state, payload: { prefixPreview: PrefixPreview }) {
        state.prefixPreview = payload.prefixPreview;

        const previewState = state.preview;
        previewState.isProcessing = false;
    },

    [types.PREFIX_PREVIEW_FAILURE](state, payload: { errorTitle: string; errorDetails: Array<ErrorDetail> }) {
        const previewState = state.preview;
        previewState.errorTitle = payload.errorTitle;
        previewState.errorDetails = payload.errorDetails;
        previewState.error = true;
        previewState.isProcessing = false;
    },

    // FATALエラー系
    [types.FATAL_FAILURE](state) {
        const showState = state.show;
        showState.isProcessing = false;
        showState.isFetchSuccess = false;

        const updateState = state.update;
        updateState.isProcessing = false;

        const previewState = state.preview;
        previewState.isProcessing = false;
    },

    [types.CLEAR_ALL](state) {
        state.applicationFormNumberSetting = undefined;

        state.show.isProcessing = false;
        state.show.isFetchSuccess = false;
        state.show.error = false;
        state.show.errorCode = undefined;
        state.show.errorMsg = undefined;

        state.update.isProcessing = false;
        state.update.error = false;
        state.update.errorTitle = undefined;
        state.update.errorDetails = undefined;

        state.preview.isProcessing = false;
        state.preview.error = false;
        state.preview.errorTitle = undefined;
        state.preview.errorDetails = undefined;
    },
};
